import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { StepGuideRoutingModule } from './step-guide-routing.module';
import { StepGuideComponent } from './step-guide.component';
import { StepGuideAdminComponent } from './step-guide-admin.component';
import { CustomFlexLayoutModule } from '../flex-layout/custom-flex-layout.module';
import { MatIconModule } from '@angular/material/icon';
import { DragDropModule } from '@angular/cdk/drag-drop';

@NgModule({
  declarations: [
    StepGuideComponent,
    StepGuideAdminComponent
  ],
  imports: [
    CommonModule,
    StepGuideRoutingModule,
    CustomFlexLayoutModule,
    MatIconModule,
    DragDropModule
  ],
  exports: [
    StepGuideComponent,
    StepGuideAdminComponent
  ]
})
export class StepGuideModule { }
